/* eslint-disable jsx-a11y/anchor-is-valid */
import axios from "axios";
import React, { Component, createRef } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import {
  set_datapage,
  SetLanguage,
  getLanguage,
} from "@ora/recursos/src/redux/actions/DataPageAction";
import { baseUrl, localUrl } from "@ora/recursos/src/helpers/Url";
import { checkObjects } from "helpers/Utils";

import qs from "query-string";
import { Chart } from "react-google-charts";
import $ from "jquery";
import dt from "datatables.net";
import "css/reportes/scrollbar.css";
import typeahead from "corejs-typeahead";

import Highcharts from "highcharts/highmaps";
import CHighcharts from "layouts/mainsection/components/CHighcharts";
import CMapHighcharts from "layouts/mainsection/components/CMapHighcharts";

import "css/reportes/fichaespecie.css";
import "css/frontend/ficha-especie.scss";
import { Button, Card, Section, Form } from "react-bulma-components";
import { prependTraces } from "plotly.js";
import defaultImg from "img/default.png";

window.Highcharts = Highcharts;
require("@highcharts/map-collection/custom/world");
require("@highcharts/map-collection/custom/south-america");
$.DataTable = dt;
$.typeahead = typeahead;
// ChartJS.register(...registerables);
const SpinLoader = (
  <div>
    <div className="ld ld-spinner  ld-spin"></div>
  </div>
);
const SpinLoaderStyle = (
  <div
    style={{
      textAlign: "center",
      height: "7em",
      position: "relative",
      top: "2.5em",
    }}
  >
    <div className="ld ld-spinner  ld-spin"></div>
  </div>
);

const hiddenBtnGenerar = {
  height: "0px",
  overflow: "hidden",
};

class Search extends Component {
  filter = {
    buscar: "",
  };
  selects = {
    cites: [],
    especies: [],
  };
  currentSelect = {
    cite: "",
    especie: 0,
    dataEspecie: null,
  };
  datatable = null;

  refiTxtSearch = null;


  BGMapChart = "#81d4fa";

  chartMapGlobal = null;

  paramsURL = {};
  requestInit = null
  requestInitTypeHead = [];
  constructor(props) {
    super(props);
    this.requestInit = axios.CancelToken.source();
    let objFinal = {};

    this.paramsURL = qs.parse(this.props.location.search);

    objFinal = {
      firstRequest: true,
      resultSearch: [],
      initRequest: false,
      showGenerar: true,
      currentPageSearch: 1,
      currentSearch: ''
    };
    // if (
    //   this.paramsURL.t !== undefined &&
    //   this.paramsURL.t >= 1 &&
    //   this.paramsURL.t <= 3
    // ) {
    //   objFinal.currentTab = +this.paramsURL.t;
    // }
    this.state = objFinal;

    this.refiTxtSearch = createRef();


    console.log(this.paramsURL);
    this.organizeUrlsGET(this.paramsURL);
  }
  organizeUrlsGET = (params) => {};
  initTypeahead = () => {
    // this.requestInitTypeHead.push(axios.CancelToken.source())
    console.log("initTypeahead");
    const fnTargetText = (e, data) => {
      this.setState({
        typeahead: {
          ...this.state.typeahead,
          pli_int_id: data.pli_int_id,
        },
      });
    };
    let countSearchs = 0;
    $("#search_especies")
      .typeahead(
        {
          highlight: true,
          hint: false,
          minLength: 1,
        },
        {
          async: true,
          name: "search-decomisos",
          display: function display(d) {
            return `${d.pli_txt_scientificname}`;
          },
          templates: {
            pending: () => {
              return `<div class="is-capitalize pl-2">${this.props.language(
                "buscando"
              )}...</div>`;
            },
            empty: () => {
              return `<div class="is-capitalize pl-2">${this.props.language(
                "sin resultados"
              )}</div>`;
            },
            suggestion: (h) => {
              // if (h.asPlaceholder !== undefined) {
              //     return `<div>Solo buscar <b>"${h.text}"</b></div>`
              // } else
              return `<div>${h.pli_txt_scientificname} <i>(${h.pli_txt_commonnames_f})</i></div>`;
            },
          },
          source: (q, cb, asy) => {
            // let result = []
            if (this.requestInitTypeHead[countSearchs - 1] !== undefined) {
              this.requestInitTypeHead[countSearchs - 1].cancel();
            }
            this.requestInitTypeHead.push(axios.CancelToken.source());
            if (q.trim() !== "") {
              // var no_buscar = _this.cilindros.map(function (v) {
              //     return v.id;
              // });
              // console.log(no_buscar);
              // axios.get(BASE_URL + '/api/cilindro?m=all&q=' + q, {params: {cilindros: no_buscar}}).then(res => {

              // cb([{count: 0, asPlaceholder: true, text: q.trim()}]);
              axios
                .get(baseUrl("cites/dashboard/getespeciesth"), {
                  params: { q: q.trim() },
                  cancelToken: this.requestInitTypeHead[countSearchs++].token,
                })
                .then(function (res) {
                  // console.log(res.data)
                  // return res.data
                  // res.data.unshift({count: 0, text: `Solo buscar "${q.trim()}"` })
                  asy(res.data.data);
                  // return res.data
                });

              // let regex = new RegExp(q, 'i');
              // cb(_this.listaBancos.filter(v => {
              //   return regex.test(v.banco_name)
              // }))
            }
          },
        }
      )
      .bind("typeahead:select", fnTargetText)
      .bind("typeahead:autocomplete", fnTargetText)
      .bind("typeahead:asyncrequest", function (e, x) {})
      .bind("typeahead:asynccancel typeahead:asyncreceive", function (e, x) {});
  };

  setDataPage = () => {
    this.props.set_datapage({
      titulo: `Buscador CITES Principal`,
      isbackend: false,
      // be_itemselect: "exportaciones_cites", //clave de item del menu backend que se debe activar
      breadcrumb: [
        { name: "Inicio", url: localUrl("/") },
        { name: "Buscador CITES general", url: "#", active: true },
      ],
    });
  };
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (100 === +this.props.countDataPage) {
      this.setDataPage();
    }
  }
  componentDidMount() {
    this.setDataPage();

    var params = qs.parse(this.props.location.search);

 
    this.initTypeahead();
  }

  initpage(result) {

  }

  componentWillUnmount() {
    if (this.requestInit) this.requestInit.cancel();
  }

  __onSubmitSearch = (query, page) => {
    if (query.trim() !== '' && query.length >= 3) {
      this.setState({
        showGenerar: false,
        firstRequest: false,
        initRequest: true
      })
      axios.get(baseUrl('cites/search'), {
        params: {
          q: query,
          p: page
        },
        cancelToken: this.requestInit.token
      }).then(res => {
        let body = []
        this.setState({
          showGenerar: true,
          initRequest: false,
          firstRequest: false,
          currentSearch: res.data.data.q,
          currentPageSearch: res.data.data.pagination.current_page,
          resultSearch: res.data.data.result
        })
      })
      .catch(err => {
        this.setState({
          showGenerar: true,
          initRequest: false,
          currentSearch: '',
          currentPageSearch: 1,
          firstRequest: false,
          resultSearch: []
        })
      })
    }
  }
  onSubmitSearch = e => {
    
    e.preventDefault()
    this.__onSubmitSearch(this.refiTxtSearch.current.value, 1)
  }
  render() {
    return (
      <div className="is-main-section">
        <Card>
          {/* <Card.Header> */}
          {/* <Card.Header.Title>
                   <span className="icon"><i className="mdi mdi-finance"></i></span>Importar
               </Card.Header.Title> */}

          {/* </Card.Header> */}
          <Card.Content>
          <h3><i>{this.props.language('ingresar_caracteres','Ingrese mínimo 3 caracteres')}</i></h3>
          <form action="" onSubmit={ this.onSubmitSearch }>


          <div className="field has-addons">
          <p className="control is-full has-icons-left has-icons-right" style={{width: '100%'}}> 
              <input ref={ this.refiTxtSearch } id="txtSearch"  className="input form-control" type="search" placeholder={this.props.language('ingresar_especie','Ingresar nombre de especie')}/>
              <span className="icon  is-left">
                <i className="fas fa-search"></i>
              </span>
            </p>
          <div className="control">
            <button disabled={ !this.state.showGenerar } className="button is-info">
              
              <div>
                <div style={ !this.state.showGenerar ? hiddenBtnGenerar : {} }>{this.props.language('buscar','Buscar')}
                </div>
                { this.state.showGenerar ? null : SpinLoader}
              </div>
            </button>
          </div>
        </div>
          <div className="field">
            
          </div>
          </form>
          
          <div id="rsultados">
            { !this.state.initRequest && !this.state.firstRequest
            ? 
            <>
              <h3>{this.props.language('resultados_para','Resultados para')}: <i><b>{ this.refiTxtSearch.current.value }</b></i></h3>
              <ul className="mt-4 pl-2" id="list_search">
                { this.state.resultSearch.length > 0 ? this.state.resultSearch.map((item, index) => {
                  let urlRef = {
                    pathname: '/listcites',
                    search: `?q2=${item.target}&q5=3`
                  }
                  // console.log(localUrl(`/listcitres?q2=${item.target}&q5=3`))
                  return (
                    <li key={ 'sr' + index } className="mb-5">
                      <div className="starget" style={{fontSize: '1.5em'}}>
                        { item.target }, <span className="srecurso">{ item.recurso }</span>
                      </div>
                      <div className="sdescription">
                        <p style={{color: 'GrayText'}}>{ item.description }</p>
                      </div>
                      <div>
                        <Link
                          to={urlRef}
                        >
                        { localUrl(urlRef.pathname + urlRef.search) }
                        </Link>
                      </div>
                    </li>
                  )
                }) : <h1><i>{this.props.language('ser_sinreultados','Sin resultados')}</i></h1> }
                
              </ul>
            </>
            : (this.state.firstRequest ? false : SpinLoaderStyle) }
          </div>
          <nav className="pagination is-centered" role="navigation" aria-label="pagination">
  <a onClick={ e => this.__onSubmitSearch(this.state.currentSearch, (+this.state.currentPageSearch - 1))} className="pagination-previous">{this.props.language('anterior','Anterior')}</a>
  <a onClick={ e => this.__onSubmitSearch(this.state.currentSearch, (+this.state.currentPageSearch + 1))} className="pagination-next">{this.props.language('siguiente','Siguiente')}</a>
  {/* <ul class="pagination-list">
    <li><a class="pagination-link" aria-label="Goto page 1">1</a></li>
    <li><span class="pagination-ellipsis">&hellip;</span></li>
    <li><a class="pagination-link" aria-label="Goto page 45">45</a></li>
    <li><a class="pagination-link is-current" aria-label="Page 46" aria-current="page">46</a></li>
    <li><a class="pagination-link" aria-label="Goto page 47">47</a></li>
    <li><span class="pagination-ellipsis">&hellip;</span></li>
    <li><a class="pagination-link" aria-label="Goto page 86">86</a></li>
  </ul> */}
</nav>
          </Card.Content>
        </Card>
      </div>
    );
  }
}

export default connect(getLanguage, { set_datapage, SetLanguage })(Search);
